import { Link } from "react-router-dom";
import "./OrderInvoice.css";
import { useReactToPrint } from "react-to-print";
import { useEffect, useRef, useState } from "react";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";
import {
  ORDERS_API,
  PRODUCTSIZE_API,
  PRODUCTS_API,
} from "../../../../Utilities/APIs/APIs";

function OrderInvoice({ targetID }) {
  const axiosInstance = useAxiosInstance();

  const [order, setOrder] = useState(null);
  const [orderItems, setOrderItems] = useState(null);

  //const lineStatus = getLineStatus(orderItems);

  // const [items, setItems] = useState(null);
  // const [productSizes, setProductSizes] = useState(null);

  useEffect(() => {
    async function fetchAndSetOrder() {
      const { data } = await axiosInstance.get(
        ORDERS_API + "getSingleOrder/" + targetID,
      );
      setOrder(data[0]);
    }

    fetchAndSetOrder();
  }, [targetID, axiosInstance]);

  useEffect(() => {
    async function fetchAndSetOrderItems() {
      const { data } = await axiosInstance.get(
        ORDERS_API + "orderItemsFromOrder/" + targetID,
      );
      setOrderItems(data.orderItems);
    }
    fetchAndSetOrderItems();

    // async function fetchAndSetItems() {
    //   const { data } = await axiosInstance.get(PRODUCTS_API);
    //   setItems(data);
    // }

    // fetchAndSetItems();

    // async function fetchAndSetSizes() {
    //   const { data } = await axiosInstance.get(PRODUCTSIZE_API);
    //   setProductSizes(data);
    // }

    // fetchAndSetSizes();
  }, [axiosInstance, targetID]);

  const conponentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "invoice",
    // onAfterPrint:()=>alert("Data saved in PDF")
  });

  const isInternational =
  order?.customerCountry &&
  order.customerCountry !== "Bangladesh" &&
  order.customerCountry !== "BD";
  const USD_RATE = 125;
  const USD_MULTIPLIER = 3;

  const convertProductToUSD = (amount = 0) =>
    ((Number(amount) * USD_MULTIPLIER) / USD_RATE).toFixed(0);

  const convertShippingToUSD = (amount = 0) =>
    (Number(amount) / USD_RATE).toFixed(0);

  const formatAmount = (
    amount,
    isInternational,
    type = "product"
  ) => {
    if (!isInternational) {
      return Math.round(Number(amount || 0));
    }

    if (type === "shipping") {
      return `USD ${convertShippingToUSD(amount)}`;
    }

    return `USD ${convertProductToUSD(amount)}`;
  };

  const discountedPrice =
    (order?.orderSubtotal - order?.promoDiscountAmount - order?.bundleDiscountAmount) * 0.1;
  const roundedDiscountedPrice = Math.round(discountedPrice);

  function getLineStatus(line) {
    const qty = Number(line.quantity || 0);

    let cancelled = Number(line.cancelQuantity || 0);

    if (!cancelled && line.isCancelled) {
      cancelled = qty;
    }

    // ITEM STATUS FIRST PRIORITY
    if (line?.itemStatus === "exchanged") {
      return "Exchanged";
    }

    if (line?.itemStatus === "refunded") {
      return "Refunded";
    }

    if (line?.itemStatus === "canceled") {
      return "Canceled";
    }

    if (
      line?.itemStatus === "delivered" ||
      line?.itemStatus === "deliveredUnpaid"
    ) {
      return "Delivered";
    }

    if (
      line?.itemStatus === "dispatchedInHouse" ||
      line?.itemStatus === "dispatchedCourier"
    ) {
      return "Dispatched";
    }

    return orderStatus;
  }

  const orderStatus = order?.orderStatus || "";

  const hasExchange = Number(order?.previousOrderTotal || 0) > 0;

  const exchangeDueAmount = Number(order?.exchangeDueAmount || 0);

  const isRefund = exchangeDueAmount < 0;

  const finalExchangeAmount = Math.abs(exchangeDueAmount);

  return (
    <div>
      <button className="submit" onClick={generatePDF}>
        Print Invoice
      </button>
      <div
        ref={conponentPDF}
        className="container invoice_padding"
        style={{
          padding: "15px 20px 20px 20px",
          marginBottom: "20px",
          backgroundColor: "#FFF",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h5 style={{ fontWeight: "bold", fontSize: "14px" }}>
            {" "}
            BIN NUMBER: 003429392-0109{" "}
          </h5>
        </div>{" "}
        <br />
        <h4 style={{ float: "right", fontWeight: "bold", fontSize: "14px" }}>
          Mushok-6.3
        </h4>
        <div className="pull-right"></div>
        {order?.giftCardRcpName ? (
          <div style={{ addingBottom: "30px", overflow: "hidden" }}>
            <div
              style={{ display: "inlineBlock", width: "25%", float: "left" }}
            >
              <div style={{ overflow: "hidden" }}>
                <p style={{ margin: "0", color: "#414040" }}>1</p>
                <hr
                  style={{
                    width: "75%",
                    float: "left",
                    borderBottom: "1px solid #ccc",
                  }}
                />
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: "12px",
                  fontWeight: "700",
                  lineHeight: "19px",
                  paddingBottom: "3px",
                  color: "#333333",
                }}
              >
                ORDER NUMBER
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.invoiceNo}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                Date: {new Date(order?.createdAt).toLocaleDateString()}
              </p>
            </div>

            <div
              style={{ display: "inlineBlock", width: "25%", float: "left" }}
            >
              <div style={{ overflow: "hidden" }}>
                <p style={{ margin: "0", color: "#414040" }}>2</p>
                <hr
                  style={{
                    width: "75%",
                    float: "left",
                    borderBottom: "1px solid #ccc",
                  }}
                />
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: "12px",
                  fontWeight: "700",
                  lineHeight: "19px",
                  paddingBottom: "3px",
                  color: "#333333",
                }}
              >
                ADDRESS
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.shippingName}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.shippingAddress},{order?.customerArea} {order?.postalCode ? ` ${order.postalCode}` : ""}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.customerDistrict}, {order?.customerCountry || "Bangladesh"}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.orderCustomerEmail}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.shippingPhone}
              </p>
            </div>
            <div
              style={{ display: "inlineBlock", width: "25%", float: "left" }}
            >
              <div style={{ overflow: "hidden" }}>
                <p style={{ margin: "0", color: "#414040" }}>3</p>
                <hr
                  style={{
                    width: "75%",
                    float: "left",
                    borderBottom: "1px solid #ccc",
                  }}
                />
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: "12px",
                  fontWeight: "700",
                  lineHeight: "19px",
                  paddingBottom: "3px",
                  color: "#333333",
                }}
              >
                ESTIMATED DELIVERY
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {new Date(
                  new Date(order?.createdAt).setDate(
                    new Date(order?.createdAt).getDate() + 3,
                  ),
                ).toLocaleDateString()}
              </p>

              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  fontWeight: "bold",
                  color: "#f26822",
                }}
              >
                {order?.gifted === "true" ? "Gift" : ""}
              </p>
            </div>

            <div
              style={{ display: "inlineBlock", width: "25%", float: "left" }}
            >
              <div style={{ overflow: "hidden" }}>
                <p style={{ margin: "0", color: "#414040" }}>4</p>
                <hr
                  style={{
                    width: "75%",
                    float: "left",
                    borderBottom: "1px solid #ccc",
                  }}
                />
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: "12px",
                  fontWeight: "700",
                  lineHeight: "19px",
                  paddingBottom: "3px",
                  color: "#f1652f",
                }}
              >
                GIFT CARD INFO
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                To: {order?.giftCardRcpEmail}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                Recipient Name: {order?.giftCardRcpName}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                Gift Card From: {order?.giftCardFrom}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                Gift Card Message: {order?.giftCardMessage}
              </p>
            </div>
          </div>
        ) : (
          <div style={{ addingBottom: "30px", overflow: "hidden" }}>
            <div
              style={{ display: "inlineBlock", width: "33.33%", float: "left" }}
            >
              <div style={{ overflow: "hidden" }}>
                <p style={{ margin: "0", color: "#414040" }}>1</p>
                <hr
                  style={{
                    width: "75%",
                    float: "left",
                    borderBottom: "1px solid #ccc",
                  }}
                />
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: "12px",
                  fontWeight: "700",
                  lineHeight: "19px",
                  paddingBottom: "3px",
                  color: "#333333",
                }}
              >
                ORDER NUMBER
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.invoiceNo}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                Date: {new Date(order?.createdAt).toLocaleDateString()}
              </p>
            </div>

            <div
              style={{ display: "inlineBlock", width: "33.33%", float: "left" }}
            >
              <div style={{ overflow: "hidden" }}>
                <p style={{ margin: "0", color: "#414040" }}>2</p>
                <hr
                  style={{
                    width: "75%",
                    float: "left",
                    borderBottom: "1px solid #ccc",
                  }}
                />
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: "12px",
                  fontWeight: "700",
                  lineHeight: "19px",
                  paddingBottom: "3px",
                  color: "#333333",
                }}
              >
                ADDRESS
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.shippingName}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.shippingAddress}, {order?.customerArea} {order?.postalCode ? ` ${order.postalCode}` : ""}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.customerDistrict}, {order?.customerCountry || "Bangladesh"}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.orderCustomerEmail}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {order?.shippingPhone}
              </p>
            </div>
            <div
              style={{ display: "inlineBlock", width: "33.33%", float: "left" }}
            >
              <div style={{ overflow: "hidden" }}>
                <p style={{ margin: "0", color: "#414040" }}>3</p>
                <hr
                  style={{
                    width: "75%",
                    float: "left",
                    borderBottom: "1px solid #ccc",
                  }}
                />
              </div>
              <p
                style={{
                  margin: "0",
                  fontSize: "12px",
                  fontWeight: "700",
                  lineHeight: "19px",
                  paddingBottom: "3px",
                  color: "#333333",
                }}
              >
                ESTIMATED DELIVERY
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  color: "#484748",
                }}
              >
                {new Date(
                  new Date(order?.createdAt).setDate(
                    new Date(order?.createdAt).getDate() + 3,
                  ),
                ).toLocaleDateString()}
              </p>

              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  lineHeight: "16px",
                  fontWeight: "bold",
                  color: "#f26822",
                }}
              >
                {order?.gifted === "true" ? "Gift" : ""}
              </p>
            </div>
          </div>
        )}
        <div style={{ overflow: "hidden", paddingTop: "20px" }}>
          <div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tr>
                <th
                  style={{
                    width: "30%",
                    textAlign: "left",
                    borderBottom: "1px solid #333333",
                    padding: "10px 3px 10px 0",
                    color: "#333333",
                    fontSize: "12px",
                  }}
                >
                  Item
                </th>

                <th
                  style={{
                    width: "15%",
                    textAlign: "left",
                    borderBottom: "1px solid #333333",
                    padding: "10px 3px 10px 0",
                    color: "#333333",
                    fontSize: "12px",
                  }}
                >
                  Qty
                </th>

                <th
                  style={{
                    width: "15%",
                    textAlign: "left",
                    borderBottom: "1px solid #333333",
                    padding: "10px 3px 10px 0",
                    color: "#333333",
                    fontSize: "12px",
                  }}
                >
                  Size
                </th>

                <th
                  style={{
                    width: "15%",
                    textAlign: "left",
                    borderBottom: "1px solid #333333",
                    padding: "10px 3px 10px 0",
                    color: "#333333",
                    fontSize: "12px",
                  }}
                >
                  Status
                </th>

                {order?.gifted === "true" ? null : (
                  <>
                    <th
                      style={{
                        width: "10%",
                        textAlign: "right",
                        borderBottom: "1px solid #333333",
                        padding: "10px 3px 10px 0",
                        color: "#333333",
                        fontSize: "12px",
                      }}
                    >
                      Price
                    </th>
                    <th
                      style={{
                        width: "15%",
                        textAlign: "right",
                        borderBottom: "1px solid #333333",
                        padding: "10px 3px 10px 0",
                        color: "#333333",
                        fontSize: "12px",
                      }}
                    >
                      Total
                    </th>
                  </>
                )}
              </tr>

              {orderItems?.length > 0 &&
                orderItems.map((orderItem) => {
                  const qty = Number(orderItem?.quantity || 0);
                  let cancelled = Number(orderItem?.cancelQuantity || 0);

                  // backward compatibility
                  if (!cancelled && orderItem?.isCancelled) {
                    cancelled = qty;
                  }

                  let qtyLabel = String(qty);
                  if (cancelled > 0 && cancelled < qty) {
                    qtyLabel = `${qty} (Canceled ${cancelled} out of ${qty})`;
                  }

                  // original full line total from DB
                  const totalPriceRaw = Number(orderItem?.totalPrice || 0);

                  // unit price = product price
                  const unitPrice =
                    qty > 0 ? Math.round(totalPriceRaw / qty) : 0;

                  const activeQty =
                    cancelled >= qty ? 0 : Math.max(0, qty - cancelled);

                  const lineTotal = unitPrice * activeQty;
                  const statusLabel = getLineStatus(orderItem);

                  return (
                    <tr
                      style={{ fontSize: "11px", lineHeight: "16px" }}
                      key={orderItem._id}
                    >
                      {/* Item name + squId */}
                      <td
                        style={{
                          borderBottom: "1px solid #333333",
                          padding: "5px 3px 15px 0",
                          color: "#040406",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          {orderItem?.item?.name}
                        </span>
                        <br />
                        <span style={{ fontSize: "9px" }}>
                          {orderItem?.item?.squId}
                        </span>
                      </td>

                      {/* Qty (original, with optional cancel note) */}
                      <td
                        style={{
                          borderBottom: "1px solid #333333",
                          padding: "5px 3px 15px 0",
                          color: "#686868",
                        }}
                      >
                        {qtyLabel}
                      </td>

                      {/* Size */}
                      <td
                        style={{
                          borderBottom: "1px solid #333333",
                          padding: "5px 3px 15px 0",
                          color: "#686868",
                        }}
                      >
                        {orderItem?.size?.name}
                      </td>

                      {/* Status (Delivered / Canceled / etc.) */}
                      <td
                        style={{
                          borderBottom: "1px solid #333333",
                          padding: "5px 3px 15px 0",
                          color: "#686868",
                        }}
                      >
                        <span
                          style={{
                            fontWeight:
                              statusLabel === "Exchanged" ? "700" : "400",

                            color:
                              statusLabel === "Exchanged"
                                ? "#f1652f"
                                : statusLabel === "Canceled"
                                  ? "#d32f2f"
                                  : statusLabel === "Delivered"
                                    ? "#2e7d32"
                                    : "#686868",
                          }}
                        >
                          {statusLabel}
                        </span>
                      </td>

                      {/* Price + Total (hidden for gift orders) */}
                      {order?.gifted === "true" ? null : (
                        <>
                          {/* unit price (product price) */}
                          <td
                            style={{
                              borderBottom: "1px solid #333333",
                              padding: "5px 3px 15px 0",
                              color: "#686868",
                              textAlign: "right",
                            }}
                          >
                            {unitPrice}
                          </td>

                          {/* active total (0 if fully canceled) */}
                          <td
                            style={{
                              borderBottom: "1px solid #333333",
                              padding: "5px 3px 15px 0",
                              color: "#686868",
                              textAlign: "right",
                            }}
                          >
                            {lineTotal}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}

              {/* <tr style={{ fontSize: "11px", lineHeight: "16px" }}>
                <td
                  style={{
                    borderBottom: "1px solid #333333",
                    padding: "5px 3px 15px 0",
                    color: "#686868",
                  }}
                >
                  product_name
                </td>
                <td
                  style={{
                    borderBottom: "1px solid #333333",
                    padding: "5px 3px 15px 0",
                    color: "#686868",
                  }}
                >
                  Pending
                </td>
                <td
                  style={{
                    borderBottom: "1px solid #333333",
                    padding: "5px 3px 15px 0",
                    color: "#686868",
                  }}
                >
                  1
                </td>
                <td
                  style={{
                    borderBottom: "1px solid #333333",
                    padding: "5px 3px 15px 0",
                    color: "#686868",
                  }}
                >
                  {" "}
                  S (UP/Down)
                </td>

                <td
                  style={{
                    borderBottom: "1px solid #333333",
                    padding: "5px 3px 15px 0",
                    color: "#686868",
                    textAlign: "right",
                  }}
                >
                  total_price
                </td>
              </tr> */}

              {order?.gifted === "true" ? (
                <tr>
                  <td style={{}}></td>
                  <td
                    colspan="4"
                    style={{
                      width: "100%",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        fontSize: "12px",
                        lineHeight: "16px",
                      }}
                    >
                      <tr>
                        <td
                          style={{
                            width: "65%",
                            color:
                              order?.shippingMethod === "express"
                                ? "#f1652f"
                                : "#686868",
                            fontWeight: "700",
                          }}
                        >
                          Delivery ({order?.shippingMethod})
                        </td>
                      </tr>

                      {order?.isGiftbox && (
                        <tr>
                          <td
                            style={{
                              width: "65%",
                              color: "#f1652f",
                              fontWeight: "700",
                            }}
                          >
                            Gift Box
                          </td>
                          <td
                            style={{
                              width: "35%",
                              textAlign: "right",
                              color: "#686868",
                              fontWeight: "700",
                            }}
                          >
                            Yes
                          </td>
                        </tr>
                      )}
                    </table>
                  </td>
                </tr>
              ) : (
                <>
                  <tr>
                    <td style={{ borderBottom: "1px solid #333333" }}></td>
                    <td
                      colspan="5"
                      style={{
                        width: "100%",
                        borderBottom: "1px solid #333333",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          fontSize: "11px",
                          lineHeight: "16px",
                        }}
                      >
                        <tr>
                          <td style={{ width: "65%", color: "#686868" }}>
                            Subtotal
                          </td>
                          <td
                            style={{
                              width: "35%",
                              textAlign: "right",
                              color: "#686868",
                            }}
                          >
                            {Math.round(order?.orderSubtotal)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "65%",
                              color:
                                order?.shippingMethod === "express"
                                  ? "#f1652f"
                                  : "#686868",
                            }}
                          >
                            Delivery ({order?.shippingMethod})
                          </td>
                          <td
                            style={{
                              width: "35%",
                              textAlign: "right",
                              color: "#686868",
                            }}
                          >
                            {order?.shippingRate}
                          </td>
                        </tr>

                        {Number(order?.promoDiscountAmount || 0) > 0 && (
                        <tr>
                          <td style={{ width: "65%", color: "#686868" }}>
                            Discount
                          </td>
                          <td
                            style={{
                              width: "35%",
                              textAlign: "right",
                              color: "#686868",
                            }}
                          >
                            -{order?.promoDiscountAmount
                              ? order?.promoDiscountAmount
                              : 0}
                          </td>
                        </tr>
                        )}

                     {Number(order?.bundleDiscountAmount || 0) > 0 && (
                          <tr>
                            <td style={{ width: "65%", color: "#686868" }}>
                              Bundle Discount
                              {order?.bundleOffers?.length
                                ? ` (${order.bundleOffers
                                    .map((offer) => offer?.name)
                                    .filter(Boolean)
                                    .join(" · ")})`
                                : order?.bundleOfferName
                                  ? ` (${order.bundleOfferName})`
                                  : ""}
                            </td>

                            <td
                              style={{
                                width: "35%",
                                textAlign: "right",
                                color: "#686868",
                              }}
                            >
                              -{order?.bundleDiscountAmount || 0}
                            </td>
                          </tr>
                        )}


                        {order?.isGiftbox && (
                          <tr>
                            <td style={{ width: "65%", color: "#f1652f" }}>
                              Gift Box
                            </td>
                            <td
                              style={{
                                width: "35%",
                                textAlign: "right",
                                color: "#686868",
                              }}
                            >
                              180
                            </td>
                          </tr>
                        )}

                        <tr>
                          <td
                            style={{
                              width: "65%",
                              fontWeight: "700",
                              paddingTop: "10px",
                              color: "#333333",
                            }}
                          >
                            Current Order Total
                          </td>

                          <td
                            style={{
                              width: "35%",
                              textAlign: "right",
                              paddingTop: "10px",
                              color: "#333333",
                              fontWeight: "700",
                            }}
                          >
                            {Math.round(order?.orderTotal || 0)}
                          </td>
                        </tr>

                        {hasExchange && (
                          <>
                            <tr>
                              <td
                                style={{
                                  width: "65%",
                                  paddingTop: "14px",
                                  color: "#686868",
                                }}
                              >
                                Customer Paid Before
                              </td>

                              <td
                                style={{
                                  width: "35%",
                                  textAlign: "right",
                                  paddingTop: "14px",
                                  color: "#686868",
                                }}
                              >
                                {Math.round(order?.previousOrderTotal || 0)}
                              </td>
                            </tr>

                            {!!Number(order?.exchangeDeliveryCharge || 0) && (
                              <tr>
                                <td
                                  style={{
                                    width: "65%",
                                    color: "#686868",
                                    paddingTop: "8px",
                                  }}
                                >
                                  Exchange Delivery Fee
                                </td>

                                <td
                                  style={{
                                    width: "35%",
                                    textAlign: "right",
                                    color: "#f1652f",
                                    paddingTop: "8px",
                                  }}
                                >
                                  {Math.round(
                                    order?.exchangeDeliveryCharge || 0,
                                  )}
                                </td>
                              </tr>
                            )}

                            <tr>
                              <td
                                style={{
                                  width: "65%",
                                  color: isRefund ? "#d32f2f" : "#f1652f",
                                  fontWeight: "700",
                                  paddingTop: "14px",
                                  borderTop: "1px dashed #ccc",
                                }}
                              >
                                {isRefund
                                  ? "Customer Will Receive Refund"
                                  : "Customer Will Pay"}
                              </td>

                              <td
                                style={{
                                  width: "35%",
                                  textAlign: "right",
                                  color: isRefund ? "#d32f2f" : "#f1652f",
                                  fontWeight: "700",
                                  paddingTop: "14px",
                                  borderTop: "1px dashed #ccc",
                                }}
                              >
                                {Math.round(finalExchangeAmount)}
                              </td>
                            </tr>
                          </>
                        )}
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td colspan="5">
                      <table
                        style={{
                          width: "100%",
                          fontSize: "11px",
                          lineHeight: "16px",
                        }}
                      >
                        <tr>
                          <td
                            style={{
                              width: "65%",
                              paddingTop: "10px",
                              color: "#686868",
                            }}
                          >
                            VAT (<span style={{ fontWeight: "bold" }}>10%</span>
                            ) Inclusive
                          </td>
                          <td
                            style={{
                              width: "35%",
                              textAlign: "right",
                              paddingTop: "10px",
                              color: "#686868",
                            }}
                          >
                            {roundedDiscountedPrice}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </>
              )}
            </table>
          </div>
        </div>
        <p
          style={{
            paddingTop: "10px",
            marginBottom: "-11px",
            fontSize: "12px",
            fontWeight: "700",
            color: "#333333",
          }}
        >
          Payment Method:{" "}
          <span
            style={{
              color:
                order?.paymentMethod === "bkash" ||
                order?.paymentMethod === "SSLCommerz"
                  ? "#f1652f"
                  : "#686868",
              fontSize:
                order?.paymentMethod === "bkash" ||
                order?.paymentMethod === "SSLCommerz"
                  ? "12px"
                  : "12px",
            }}
          >
            {order?.paymentMethod === "cash"
              ? "Cash on Delivery"
              : order?.paymentMethod === "bkash"
                ? "Paid by Bkash"
                : order?.paymentMethod === "SSLCommerz"
                  ? "Paid by SSLCOMMERZ"
                  : order?.paymentMethod}
          </span>
        </p>
        <p
          style={{
            paddingTop: "33px",
            marginBottom: "-11px",
            fontSize: "12px",
            fontWeight: "700",
            color: "#333333",
          }}
        >
          Additional Instructions:{" "}
          <span style={{ color: "#f1652f", fontSize: "12px" }}>
            {order?.additionalInstructions}
          </span>
        </p>
        <div
          style={{
            fontSize: "11px",
            lineHeight: "12px",
            overflow: "hidden",
            paddingTop: "40px",
            color: "#686868",
          }}
        >
          <p style={{ lineHeight: "13px" }}>Changed your mind?</p>
          <p style={{ lineHeight: "13px" }}>
            Don&#39;t Worry! You can easily return or exchange your items
            (within 7 days) of delivery.
          </p>
          <p style={{ lineHeight: "13px" }}>
            Visit our{" "}
            <Link
              style={{
                textDecoration: "none",
                color: "#686868",
                fontWeight: "600",
              }}
            >
              {" "}
              Returns Policy
            </Link>{" "}
            page on website, or{" "}
            <Link
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#686868",
                fontWeight: "600",
              }}
            >
              Contact Us
            </Link>{" "}
            for more information.
            <br />
            <br />
            Thank you for shopping on Strides Co!
          </p>
        </div>
        <div
          style={{
            overflow: "hidden",
            paddingTop: "30px",
            fontSize: "11px",
            lineHeight: "12px",
            color: "#686868",
          }}
        >
          <p>Warm Regards</p>
          <p style={{ fontWeight: "bold", color: "#323232" }}>
            The StridesCo Team
          </p>
          <p>
            <Link
              style={{
                fontWeight: "bold",
                fontSize: "11px",
                color: "#f26822",
                textDecoration: "none",
              }}
            >
              www.stridesco.com
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default OrderInvoice;
